export const tokens = () => {
  return {
    instagram: '14941820587.1677ed0.8eb8227cb57446f5a8925f30a9c64b6f'
  }
}
